import type { ParamsValidator } from 'src/components/RouteParamsValidator.tsx';
import type { ApprovalRouteParams, CampaignManagementRouteParams } from './types.ts';
import { ApprovalStatus, DigitalOperationStatus } from './types.ts';

const VALID_APPROVAL_STATUSES = Object.values(ApprovalStatus);
const VALID_DIGITAL_OPERATION_STATUSES = Object.values(DigitalOperationStatus).filter(
  (status) => status !== DigitalOperationStatus.PENDING_APPROVAL,
);

export const validateApprovalStatus: ParamsValidator<ApprovalRouteParams> = ({ status }) => VALID_APPROVAL_STATUSES.includes(status);

export const validateDigitalOperationStatus: ParamsValidator<CampaignManagementRouteParams> = ({ status }) =>
  // TODO: Fix this the next time the file is edited.
  // @ts-expect-error fix later
  VALID_DIGITAL_OPERATION_STATUSES.includes(status);
